// extracted by mini-css-extract-plugin
export default {"selectGroup":"lEXbX"};